import { Loading } from "@/components/ui/loading";

export function SessionsLoading() {
  return <Loading messageKey="sessions.loading" />;
}